

<template>
    <BModal :model-value="modal" scrollable size="lg" centered title="Guest" @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Program</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
                >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BTabs content-class="mt-3" v-model="tabIndex" >
            <BTab title="Detail">
                
                    <BRow class="mb-3">
                        <BCol>
                            <BFormInput placeholder="Program Name"></BFormInput>
                        </BCol>
                    </BRow>

                    <BRow class="mb-3">
                        <BCol>
                            <BFormInput type="number" placeholder="Pax"></BFormInput>
                        </BCol>
                    </BRow>

                    <BRow>
                        <BCol>
                            <BFormSelect v-model="tabDestination.selectFrom" :options="optionDestination"></BFormSelect>
                        </BCol>
                        <BCol>
                            <BFormSelect v-model="tabDestination.selectTo" :options="optionDestination" ></BFormSelect>
                        </BCol>
                    </BRow>
               
            </BTab>

            <BTab title="Transportation">
                <BRow v-for="(item, index) in tabTransportation.data" :key="index" class="mb-3">
                    <BCol class="d-flex">
                        
                        <BFormInput type="number" v-model="item.pax" placeholder="Pax"></BFormInput>
                    </BCol>
                    <BCol>
                        <BFormSelect v-model="tabTransportation.data[index].transportation" :options="optionTransportation" ></BFormSelect>
                    </BCol>
                </BRow>
                <BButton variant="danger" @click="removeTransport()" class="mr-2">-</BButton>
                <BButton variant="info" @click="addTransport()">+</BButton>
               
            </BTab>

            <BTab title="Accomodation">
                <BRow class="mb-3">
                    <h5>Destination : {{ tabDestination.selectTo }}</h5>
                </BRow>
                <BCard v-for="(item, index) in tabAccommodation.data" :key="index" class="mb-3">
                    <BRow  class="mb-2">
                    
                        <BCol>
                            <BFormSelect v-model="tabAccommodation.data[index].hotel" :options="optionAccommodation.hotel" ></BFormSelect>
                        </BCol>
                        <BCol>
                            <BFormSelect v-model="tabAccommodation.data[index].room_type" :options="optionAccommodation.room_type" ></BFormSelect>
                        </BCol>
                        <BCol>
                            <BFormSelect v-model="tabAccommodation.data[index].room_config" :options="optionAccommodation.room_config" ></BFormSelect>
                        </BCol>
                    
                    </BRow>
                    <BRow>
                        <BCol>
                            <BFormCheckbox 
                                v-model="tabAccommodation.data[index].extra_bed"
                                value="yes"
                                unchecked-value="no"
                                class="ml-1"
                            >Extra Bed
                            </BFormCheckbox>
                        </BCol>
                    </BRow>
                </BCard>
                <BButton variant="danger" @click="removeAccom()" class="mr-2">-</BButton>
                <BButton variant="info" @click="addAccom()">+</BButton>
            </BTab>
            <BTab title="Activity">
                <BRow class="mb-3">
                    <h5>Destination : {{ tabDestination.selectTo }}</h5>
                </BRow>
                <BCard v-for="(item, index) in tabAccommodation.data" :key="index" class="mb-3">
                    <BRow  class="mb-2">
                    
                        <BCol>
                            <BFormInput placeholder="Activity Name"></BFormInput>
                        </BCol>
                        <BCol>
                            <BFormInput type="number" placeholder="Price"></BFormInput>
                        </BCol>
                    </BRow>
                    <BRow>
                        <BCol>
                            <BFormTextarea placeholder="Description"></BFormTextarea>
                        </BCol>
                    </BRow>
                   
                </BCard>
                <BButton variant="danger" @click="removeAccom()" class="mr-2">-</BButton>
                <BButton variant="info" @click="addAccom()">+</BButton>
            </BTab>

            <BTab title="Consumption">
                <BRow class="mb-3 ml-3">
                    <BCol class="d-flex">
                        <BFormRadio v-model="tabConsumption" value="none">None</BFormRadio>
                        
                    </BCol>
                    <BCol>
                        <BFormRadio v-model="tabConsumption" value="lunch">Lunch</BFormRadio>
                    </BCol>
                    <BCol>
                        <BFormRadio v-model="tabConsumption" value="dinner">Dinner</BFormRadio>
                    </BCol>
                </BRow>
                <BRow v-if="tabConsumption !== 'none'">
                    <BCol>
                        <BFormInput type="number" placeholder="price"></BFormInput>
                    </BCol>
                </BRow>
            </BTab>

            <BTab title="Inclusion & Exclusion">
                <BRow class="mb-3">
                    <BCol>
                        <label for="">Inclusions</label>
                        <BFormTextarea placeholder="Inclusion"></BFormTextarea>
                    </BCol>
                </BRow>
                <BRow >
                    <BCol>
                        <label for="">Exclusions</label>
                        <BFormTextarea placeholder="Exclusion"></BFormTextarea>
                    </BCol>
                </BRow>
            </BTab>
        </BTabs>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <!-- <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton> -->
                <BButton :disabled="tabIndex > 0 ? false : true" variant="secondary" @click="tabIndex--"  class="mr-2">Prev</BButton>
                <BButton v-if="tabIndex !== 5 " variant="primary" @click="tabIndex++"  class="mr-2">Next</BButton>
                <BButton v-if="tabIndex === 5 " variant="primary"  class="mr-2">Save</BButton>
                
            </div>
        </template>
    </BModal>
</template>

<script >     
import { BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BCard, BFormCheckbox, BFormTextarea, BFormRadio } from 'bootstrap-vue-next';
import { ref, reactive} from 'vue'


export default{
    name : 'DriverGuideForm',
    props : {
        modal: Boolean,
    },
    components : {
        BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BCard, BFormCheckbox, BFormTextarea, BFormRadio
    },
    emits: ["update:modal"],
    setup(props, {emit}){
        const tabIndex = ref(0)
        
        // Tab Destination
        const tabDestination = reactive({
            
            selectFrom : 'From',
            selectTo : 'To',  
        })

        // Tab Transportation
        const tabTransportation = reactive({
            data : ref([
                {pax : '', transportation : 'choose'},
            ]),
        })
        const addTransport = ()=>{
            tabTransportation.data.push({pax:'',transportation:'choose'})
        }
        const removeTransport = ()=>{
            tabTransportation.data.pop()
        }

        // Tab Accomodation
        const tabAccommodation = reactive({
            data : ref([
                {hotel : 'none', room_type : 'none', room_config : 'none', extra_bed: false},
            ]),

        })
        const addAccom = ()=>{
            tabAccommodation.data.push({hotel:'none',room_type:'none', room_config:'none', extra_bed: false})
        }
        const removeAccom = ()=>{
            tabAccommodation.data.pop()
        }

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };

        // Tab Activity
        const tabActivity = reactive({
            data : ref([
                {name : '', price : '',},
            ]),

        })
        const addActivity = ()=>{
            tabActivity.data.push({name : '', price : '',})
        }
        const removeActivity = ()=>{
            tabActivity.data.pop()
        }

        // tab Consumption
        const tabConsumption = ref('none')

        // dummy option data
        const optionDestination = ref([
            {value : 'From', text : 'From'},
            {value : 'To', text : 'To'},
            {value : 'MDN', text : 'MDN'},
            {value : 'BKL', text : 'BKL'},
        ])

        const optionTransportation = ref([
            {value : 'choose', text : 'Choose vehicle'},
            {value : 'Avanza', text : 'Avanza'},
            {value : 'Hice', text : 'Hice'},
        ])

        const optionAccommodation = ref({
                hotel : [
                    {value : 'none', text : 'Select Hotel'},
                    {value : 'HDR', text : 'Hotel Deli River'},
                    {value : 'ECO', text : 'Ecolodge Hotel'},
                ],
                room_type : [
                    {value : 'none', text : 'Select Room Type'},
                    {value : 'Deluxe', text : 'Deluxe'},
                    {value : 'Super Deluxe', text : 'Super Deluxe'},
                ],
                room_config : [
                    {value : 'none', text : 'Select Configuration'},
                    {value : 'connected_room', text : 'Connected Room'},
                    {value : 'double_bed', text : 'Double Bed'},
                ]
        })

        return {
            tabDestination,
            tabTransportation,
            addTransport,
            removeTransport,
            tabAccommodation,
            addAccom,
            removeAccom,
            tabActivity,
            addActivity,
            removeActivity,
            tabConsumption,
            optionDestination,
            optionTransportation,
            optionAccommodation,
            updateModal,
            tabIndex
            
        }
    }
}


</script>

